import type { ThemeTypes } from '@/types/themeTypes/ThemeType';

/** Dark companion — deep navy + indigo/teal accents */
const DARK_BLUE_THEME: ThemeTypes = {
  name: 'DARK_BLUE_THEME',
  dark: true,
  variables: {
    'border-color': '#2a3a55',
    'border-opacity': 1,
  },
  colors: {
    primary: '#2DD4BF',
    secondary: '#38BDF8',
    info: '#38BDF8',
    success: '#4ADE80',
    warning: '#FBBF24',
    error: '#FB7185',
    lightprimary: '#134E4A',
    lightsecondary: '#0C4A6E',
    lightsuccess: '#14532D',
    lighterror: '#4C0519',
    lightinfo: '#0C4A6E',
    lightwarning: '#422006',
    textPrimary: '#E8F1F4',
    textSecondary: '#9DB0BA',
    borderColor: '#1F3A42',
    containerBg: '#0A151C',
    background: '#071018',
    hoverColor: '#12282E',
    surface: '#102028',
    grey100: '#12282E',
    grey200: '#C8D4E6',
    light: '#12282E',
    muted: '#9DB0BA',
  },
};

export { DARK_BLUE_THEME };
